<script setup lang="ts">
  import { Switch as ArkSwitch } from '@ark-ui/vue';
  import { computed, useId } from 'vue';
  import FormField from '../FormField/FormField.vue';
  import { controlClass, rootClass, thumbClass } from './Switch.css';
  import type { SwitchEmits, SwitchProps } from './Switch.types';

  const props = withDefaults(defineProps<SwitchProps>(), {
    disabled: false,
    required: false,
  });

  const emit = defineEmits<SwitchEmits>();

  const autoId = useId();
  const inputId = computed(() => props.id ?? autoId);

  const rootProps = computed(() => ({
    ids: { hiddenInput: inputId.value },
    disabled: props.disabled,
    required: props.required,
    invalid: !!props.error,
    name: props.name,
    value: props.value,
    checked: props.modelValue,
    onCheckedChange: (details: { checked: boolean }) =>
      emit('update:modelValue', details.checked),
  }));
</script>

<template>
  <FormField
    :id="inputId"
    :label="label"
    :helper-text="helperText"
    :error="error"
    :announce-warning="false"
    :disabled-reason="disabled ? disabledReason : undefined"
  >
    <template #default="{ describedBy }">
      <ArkSwitch.Root v-bind="rootProps" :class="rootClass">
        <ArkSwitch.Control :class="controlClass">
          <ArkSwitch.Thumb :class="thumbClass" />
        </ArkSwitch.Control>
        <ArkSwitch.HiddenInput :aria-describedby="describedBy" />
      </ArkSwitch.Root>
    </template>
  </FormField>
</template>
